import {
  TAPPING_DONE_HISTORY_FAILED,
  TAPPING_DONE_HISTORY_REQUEST,
  TAPPING_DONE_HISTORY_SUCCESS,
} from "../../../../actions/Factory/Tapping/tappingDoneHistory/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const tappingDoneHistoryReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case TAPPING_DONE_HISTORY_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case TAPPING_DONE_HISTORY_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case TAPPING_DONE_HISTORY_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
